/**
 * Platform UI themes — add/edit tokens here when you design theme 2 & 3.
 * CSS variables are applied via [data-theme] in src/styles/themes.css
 */

export const DEFAULT_THEME_ID = 'trust-blue';

export const THEME_STORAGE_KEY = 'PetsFostering-theme';
export const PLATFORM_THEME_CACHE_KEY = 'PetsFostering-platform-theme';

export const THEMES = {
  'trust-blue': {
    id: 'trust-blue',
    name: 'Trust Blue',
    description: 'Confident blue palette with purple-pink CTAs — current default',
    status: 'active',
    swatches: ['#2563EB', '#7C3AED', '#F0F5FF'],
  },
  'charcoal-mint': {
    id: 'charcoal-mint',
    name: 'Charcoal & Mint',
    description: 'Legacy neutral dashboard palette',
    status: 'active',
    swatches: ['#0C0F14', '#EAF3EF', '#F6F7F5'],
  },
  'classic-brand': {
    id: 'classic-brand',
    name: 'Classic Purple',
    description: 'Original PetsFostering purple & pink brand',
    status: 'active',
    swatches: ['#8B5CF6', '#EC4899', '#FFFFFF'],
  },
  'brand-guidelines': {
    id: 'brand-guidelines',
    name: 'Brand Guidelines v1',
    description: 'Official palette — Compassion Teal, Warm Coral & Warm White',
    status: 'active',
    swatches: ['#3FA7A3', '#F47C6B', '#FFFDF9'],
  },
  'custom-b': {
    id: 'custom-b',
    name: 'Haven UI',
    description: 'Warm, calm fostering experience inspired by the Haven design system',
    status: 'active',
    swatches: ['#D9898F', '#FAF2EB', '#A8BEA2'],
  },
};

export const getThemeList = () => Object.values(THEMES);

export const getTheme = (id) => THEMES[id] || THEMES[DEFAULT_THEME_ID];

export const isThemeId = (id) => Boolean(THEMES[id]);
